<template>
	<v-card elevation="0" outlined class="pa-1 mt-0">
		<v-row no-gutters class="mb-2 d-flex" style="justify-content: flex-end"
			><v-btn
				v-if="
					(canEdit && newInteraction == false) ||
					(canAdd && newInteraction == true)
				"
				color="error"
				height="26px"
				width="26px"
				@click="remove()"
				x-small
				><v-icon>mdi-window-close</v-icon></v-btn
			></v-row
		>
		<v-form ref="form">
			<v-row no-gutters>
				<v-select
					outlined
					dense
					v-model="action.Value"
					:items="actionType"
					item-value="value"
					item-text="text"
					hide-details="true"
					label="Action"
					class="mb-2"
				></v-select>
				<v-select
					outlined
					dense
					:rules="dataFieldRules"
					v-model="action.FormFieldId"
					hide-details="true"
					:items="formFields"
					item-text="Label"
					item-value="Id"
					label="Form field"
					class="mb-2 dataFieldDropdown"
				>
				</v-select>
				<v-textarea
					outlined
					rows="2"
					:rules="commentRules"
					label="Value"
					v-model="action.Comment"
					dense
					hide-details="true"
					v-if="showComment"
				></v-textarea>
			</v-row>
		</v-form>
	</v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import {
	InventoryFormAction,
	InventoryFormActionTypes,
} from '../../../../enums/inventoryFormAction';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { InteractionsGetters } from '../../../../store/getters';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
export default {
	name: 'FormAction',
	mixins: [permissionsMixin],
	data() {
		return {
			dataFieldRules: [(v) => !!v || 'Data field is required'],
			commentRules: [
				(v) => {
					if (this.action.Value != InventoryFormAction.Set) {
						return (
							(!!v && this.showComment == true) ||
							'Value is required'
						);
					}
				},
			],
			actionType: InventoryFormActionTypes,
		};
	},

	computed: {
		...mapGetters({
			formFields: [InteractionsGetters.FORM_FIELDS],
		}),
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.Edit,
			]);
		},
		showComment() {
			if (
				this.action.Value == InventoryFormAction.HideHelp ||
				this.action.Value == InventoryFormAction.HideBubble ||
				this.action.Value == InventoryFormAction.Hide ||
				this.action.Value == InventoryFormAction.Show ||
				this.action.Value == InventoryFormAction.Clear
			)
				return false;
			return true;
		},
	},
	watch: {
		'action.Value'(newValue) {
			if (
				newValue != InventoryFormAction.HideHelp &&
				newValue != InventoryFormAction.HideBubble &&
				newValue != InventoryFormAction.Hide &&
				(newValue == InventoryFormAction.Set ||
					newValue == InventoryFormAction.Clear)
			) {
				this.action.Comment = null;
			}
		},
	},
	props: {
		newInteraction: Boolean,
		index: Number,
		action: Object,
	},
	methods: {
		remove() {
			ConfirmDialog({
				message: 'Are you sure you want to delete this action?',
			}).then((isDelete) => {
				if (isDelete) {
					this.$emit('remove', this.index);
				}
			});
		},
		validate() {
			return this.$refs.form.validate();
		},
	},
};
</script>
<style scoped>
.dataFieldDropdown {
	width: 100%;
}
</style>
